import { Box, Grid, Typography } from "@mui/material"
import Card from "components/Card/Card"
import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import CommonModal from "components/CommonModal"
import CommonDragAndDrop from "components/CommonDragAndDrop"
import React, { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getPrivacyPolicyAction, uploadPrivacyPolicyDocumentAction } from "redux/superAdmin/actions"
import SaveAltIcon from "@mui/icons-material/SaveAlt"
import { createBreadcrumbs } from "helpers/breadCrumbs"

const PrivacyPolicy = () => {
  const dispatch = useDispatch()
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)
  const [breadCrumb, setBreadCrumb] = useState([])
  const [isUploadEnabled, setIsUploadEnabled] = useState(false)
  const { privacyPolicy } = useSelector((state) => state.superAdmin)
  const isPolicyUploaded = Boolean(privacyPolicy?.pnp_url)

  const noop = () => {}

  useEffect(() => {
    setBreadCrumb(createBreadcrumbs())
    document.title = "Policy & Procedures"
    dispatch(getPrivacyPolicyAction())
  }, [])

  const handleModalClose = () => {
    setIsUploadModalOpen(false)
    setSelectedFile(null)
    setIsUploadEnabled(false)
  }

  const handleUploadSubmit = () => {
    if (!selectedFile) {
      return
    }

    dispatch(
      uploadPrivacyPolicyDocumentAction({
        file: selectedFile,
        title: "Privacy Policy",
        description: "Privacy Policy",
        onClose: handleModalClose
      })
    )
  }

  const isSubmitDisabled = useMemo(() => {
    return !isUploadEnabled
  }, [isUploadEnabled])

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Header title="Policy & Procedures" breadCrumbs={breadCrumb}>
            <AppButton onClick={() => setIsUploadModalOpen(true)}>
              {isPolicyUploaded ? "Update Policy & Procedures" : "Add Policy & Procedures"}
            </AppButton>
          </Header>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <Box sx={{ textAlign: "center", py: 6 }}>
              <Typography variant="h4" sx={{ mb: 2 }}>
                {isPolicyUploaded
                  ? "Policy & Procedures already uploaded. Use the button above to update the document."
                  : "No Policy & Procedures uploaded yet. Use the button above to add one."}
              </Typography>
              {isPolicyUploaded && (
                <AppButton
                  startIcon={<SaveAltIcon />}
                  onClick={() => window.open(privacyPolicy.pnp_url, "_blank")}>
                  Download Policy & Procedures
                </AppButton>
              )}
            </Box>
          </Card>
        </Grid>
      </Grid>

      <CommonModal
        open={isUploadModalOpen}
        onClose={handleModalClose}
        hideAction={!selectedFile}
        actionButtons={
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2, pb: 2 }}>
            <AppButton variant="outlined" onClick={handleModalClose}>
              Cancel
            </AppButton>
            <AppButton onClick={handleUploadSubmit} disabled={isSubmitDisabled}>
              Upload
            </AppButton>
          </Box>
        }>
        <Box sx={{ padding: { xs: 3, md: 4 } }}>
          <Typography variant="h2" textAlign="center">
            Upload Policy & Procedures
          </Typography>

          <Box sx={{ mt: 4 }}>
            <CommonDragAndDrop
              accept=".pdf"
              type="PDF"
              setDisable={setIsUploadEnabled}
              setAllFilesSelected={noop}
              onChange={(file) => setSelectedFile(file)}
              preview={true}
              selectedFile={selectedFile}
              setSelectedFile={setSelectedFile}
            />
          </Box>
        </Box>
      </CommonModal>
    </>
  )
}

export default PrivacyPolicy
